"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.movePoint = movePoint;
/**
 * Create a new Point that has been moved by the delta, but is constrained within the bounds of the resolution
 *
 * @param obj Starting point
 * @param delta Amount to move the starting point
 * @param resolution Bounds of the image to keep within
 * @param maxOffset Size of the object that is being moved
 */
function movePoint(obj, delta, resolution, maxOffset) {
    var output = {
        x: obj.x + delta.x,
        y: obj.y + delta.y,
    };
    var offsetX = maxOffset == null ? 0 : maxOffset.width || 0;
    var offsetY = maxOffset == null ? 0 : maxOffset.height || 0;
    if (output.x < 0) {
        output.x = 0;
    }
    if (output.y < 0) {
        output.y = 0;
    }
    if (output.y + offsetY > resolution.height) {
        output.y = resolution.height - offsetY;
    }
    if (output.x + offsetX > resolution.width) {
        output.x = resolution.width - offsetX;
    }
    return output;
}
//# sourceMappingURL=util.js.map